/* eslint-disable import/no-cycle */
import React from 'react';
import style from './editListingPage.module.scss';
import { EditListinPageInterface } from './editListingPageTypes';
import { category, cities } from '../../constants/constants';
import EditListing from '../../pageParts/createListing/editListing';

const EditListingPage: React.FC<EditListinPageInterface> = ({ data }) => (
  <div className={style.createListingPageStyle}>
    <EditListing editData={data || null} category={category} city={cities} />
  </div>
);

export default EditListingPage;
